import { getPrivateApi } from "../lib/axiosConfig";
import { UnconfiguredDevice } from "../types/unconfiguredDevices.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/machine-config";

export const getUnconfiguredDevices = async (): Promise<UnconfiguredDevice[]> => {
  try {
    const { data } = await api.get(`${endpoint}`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar dispositivos não configurados";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const deleteUnconfiguredDevice = async (id: string): Promise<void> => {
  try {
    await api.delete(`${endpoint}/${id}`);
  } catch (error: any) {
    const errMsg = "Erro ao deletar dispositivo não configurado";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};